import { HttpInterceptorFn } from '@angular/common/http';

const API_TRANSLATION = 'api/translation';

export const translationInterceptor: HttpInterceptorFn = (req, next) => {
    
    const newReq = (req.url.includes(API_TRANSLATION) && req.url.endsWith('.json'))
        ? req.clone({ url: req.url.slice(0, req.url.length - 5) })
        : req.clone();
    
    return next(newReq);
};
